/** general **/
export const GET_PAGE = 'GET_PAGE';
export const ADD_API_CALL_IN_PROGRESS = 'ADD_API_CALL_IN_PROGRESS';
export const REMOVE_API_CALL_IN_PROGRESS = 'REMOVE_API_CALL_IN_PROGRESS';
export const MOVE_SECTION = 'MOVE_SECTION';
export const NEW_SECTION = 'NEW_SECTION';
export const SAVED_PAGE = 'SAVED_PAGE';
export const FETCHED_ELEMENTS = 'FETCHED_ELEMENTS';
export const DELETE_SECTION_IN_PAGE_STATE = 'DELETE_SECTION_IN_PAGE_STATE';
export const ENABLE_SECTION_IN_PAGE_STATE = 'ENABLE_SECTION_IN_PAGE_STATE';
export const DISABLE_SECTION_IN_PAGE_STATE = 'DISABLE_SECTION_IN_PAGE_STATE';
export const UPDATE_SECTION_GROUP_IN_PAGE_STATE =
    'UPDATE_SECTION_GROUP_IN_PAGE_STATE';
export const PICK_PARENT_PAGE = 'PICK_PARENT_PAGE';
export const DISCARD_CHANGES = 'DISCARD_CHANGES';
export const SET_PAGE_PREVIEW = 'SET_PAGE_PREVIEW';
export const HAS_ERROR = 'HAS_ERROR';

/** page picker for sections popup **/
export const OPEN_PAGE_PICKER = 'OPEN_PAGE_PICKER';
export const CLOSE_PAGE_PICKER = 'CLOSE_PAGE_PICKER';

/** page url popup **/
export const DONE_EDIT_URL_POPUP = 'DONE_EDIT_URL_POPUP';
export const UPDATE_NEW_URL_IN_THE_URL_EDIT_POPUP =
    'UPDATE_NEW_URL_IN_THE_URL_EDIT_POPUP';
export const UPDATE_NO_INDEX_IN_THE_URL_EDIT_POPUP =
    'UPDATE_NO_INDEX_IN_THE_URL_EDIT_POPUP';
export const INVALIDATE_URL_IN_THE_URL_EDIT_POPUP =
    'INVALIDATE_URL_IN_THE_URL_EDIT_POPUP';
export const CLOSE_URL_EDIT_POPUP = 'CLOSE_URL_EDIT_POPUP';
export const OPEN_URL_EDIT_POPUP = 'OPEN_URL_EDIT_POPUP';

/** product tagos id popup **/
export const OPEN_PRODUCT_TAGOS_ID_EDIT_POPUP =
    'OPEN_PRODUCT_TAGOS_ID_EDIT_POPUP';
export const UPDATE_PRODUCT_TAGOS_ID_EDIT_POPUP =
    'UPDATE_PRODUCT_TAGOS_ID_EDIT_POPUP';
export const CLOSE_PRODUCT_TAGOS_ID_EDIT_POPUP =
    'CLOSE_PRODUCT_TAGOS_ID_EDIT_POPUP';
export const DONE_EDIT_PRODUCT_TAGOS_ID_POPUP =
    'DONE_EDIT_PRODUCT_TAGOS_ID_POPUP';

/** page tags popup **/
export const OPEN_PAGE_TAGS_EDIT_POPUP = 'OPEN_PAGE_TAGS_EDIT_POPUP';
export const UPDATE_PAGE_TAGS_EDIT_POPUP = 'UPDATE_PAGE_TAGS_EDIT_POPUP';
export const CLOSE_PAGE_TAGS_EDIT_POPUP = 'CLOSE_PAGE_TAGS_EDIT_POPUP';
export const DONE_EDIT_PAGE_TAGS_POPUP = 'DONE_EDIT_PAGE_TAGS_POPUP';
export const UPDATE_MULTIPLE_PAGE_TAGS = 'UPDATE_MULTIPLE_PAGE_TAGS';

/** meta section and popup **/
export const OPEN_EDIT_META_SECTION_POPUP = 'OPEN_EDIT_META_SECTION_POPUP';
export const CLOSE_EDIT_META_SECTION_POPUP = 'CLOSE_EDIT_META_SECTION_POPUP';
export const DONE_EDIT_META_SECTION_POPUP = 'DONE_EDIT_META_SECTION_POPUP';

/** text section **/
export const OPEN_EDIT_TEXT_SECTION_POPUP = 'OPEN_EDIT_TEXT_SECTION_POPUP';
export const CLOSE_EDIT_TEXT_SECTION_POPUP = 'CLOSE_EDIT_TEXT_SECTION_POPUP';
export const DONE_EDIT_TEXT_SECTION_POPUP = 'DONE_EDIT_TEXT_SECTION_POPUP';

/** text column single media section **/
export const OPEN_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP =
    'OPEN_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP';
export const CLOSE_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP =
    'CLOSE_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP';
export const DONE_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP =
    'DONE_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP';

/** staff section **/
export const OPEN_EDIT_STAFF_SECTION_POPUP = 'OPEN_EDIT_STAFF_SECTION_POPUP';
export const CLOSE_EDIT_STAFF_SECTION_POPUP = 'CLOSE_EDIT_STAFF_SECTION_POPUP';
export const DONE_EDIT_STAFF_SECTION_POPUP = 'DONE_EDIT_STAFF_SECTION_POPUP';

/** itinerary section **/
export const OPEN_EDIT_ITINERARY_SECTION_POPUP =
    'OPEN_EDIT_ITINERARY_SECTION_POPUP';
export const CLOSE_EDIT_ITINERARY_SECTION_POPUP =
    'CLOSE_EDIT_ITINERARY_SECTION_POPUP';
export const DONE_EDIT_ITINERARY_SECTION_POPUP =
    'DONE_EDIT_ITINERARY_SECTION_POPUP';

/** reviews section **/
export const OPEN_EDIT_REVIEWS_SECTION_POPUP =
    'OPEN_EDIT_REVIEWS_SECTION_POPUP';
export const CLOSE_EDIT_REVIEWS_SECTION_POPUP =
    'CLOSE_EDIT_REVIEWS_SECTION_POPUP';
export const DONE_EDIT_REVIEWS_SECTION_POPUP =
    'DONE_EDIT_REVIEWS_SECTION_POPUP';

/** block section **/
export const OPEN_EDIT_BLOCK_SECTION_POPUP = 'OPEN_EDIT_BLOCK_SECTION_POPUP';
export const CLOSE_EDIT_BLOCK_SECTION_POPUP = 'CLOSE_EDIT_BLOCK_SECTION_POPUP';
export const DONE_EDIT_BLOCK_SECTION_POPUP = 'DONE_EDIT_BLOCK_SECTION_POPUP';

/** partners **/
export const OPEN_EDIT_PARTNERS_SECTION_POPUP =
    'OPEN_EDIT_PARTNERS_SECTION_POPUP';
export const CLOSE_EDIT_PARTNERS_SECTION_POPUP =
    'CLOSE_EDIT_PARTNERS_SECTION_POPUP';
export const DONE_EDIT_PARTNERS_SECTION_POPUP =
    'DONE_EDIT_PARTNERS_SECTION_POPUP';

/** overview **/
export const OPEN_EDIT_OVERVIEW_SECTION_POPUP =
    'OPEN_EDIT_OVERVIEW_SECTION_POPUP';
export const CLOSE_EDIT_OVERVIEW_SECTION_POPUP =
    'CLOSE_EDIT_OVERVIEW_SECTION_POPUP';
export const DONE_EDIT_OVERVIEW_SECTION_POPUP =
    'DONE_EDIT_OVERVIEW_SECTION_POPUP';

/** map section **/
export const OPEN_EDIT_MAP_SECTION_POPUP = 'OPEN_EDIT_MAP_SECTION_POPUP';
export const CLOSE_EDIT_MAP_SECTION_POPUP = 'CLOSE_EDIT_MAP_SECTION_POPUP';
export const DONE_EDIT_MAP_SECTION_POPUP = 'DONE_EDIT_MAP_SECTION_POPUP';

/** form section **/
export const OPEN_EDIT_FORM_SECTION_POPUP = 'OPEN_EDIT_FORM_SECTION_POPUP';
export const CLOSE_EDIT_FORM_SECTION_POPUP = 'CLOSE_EDIT_FORM_SECTION_POPUP';
export const DONE_EDIT_FORM_SECTION_POPUP = 'DONE_EDIT_FORM_SECTION_POPUP';
export const FETCHED_FORM_TYPES = 'FETCHED_FORM_TYPES';

/** trip formats section **/
export const OPEN_EDIT_TRIP_FORMATS_SECTION_POPUP =
    'OPEN_EDIT_TRIP_FORMATS_SECTION_POPUP';
export const CLOSE_EDIT_TRIP_FORMATS_SECTION_POPUP =
    'CLOSE_EDIT_TRIP_FORMATS_SECTION_POPUP';
export const DONE_EDIT_TRIP_FORMATS_SECTION_POPUP =
    'DONE_EDIT_TRIP_FORMATS_SECTION_POPUP';

/** product snippets section **/
export const OPEN_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP =
    'OPEN_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP';
export const CLOSE_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP =
    'CLOSE_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP';
export const DONE_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP =
    'DONE_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP';

/** internal links section **/
export const OPEN_EDIT_INTERNAL_LINKS_SECTION_POPUP =
    'OPEN_EDIT_INTERNAL_LINKS_SECTION_POPUP';
export const CLOSE_EDIT_INTERNAL_LINKS_SECTION_POPUP =
    'CLOSE_EDIT_INTERNAL_LINKS_SECTION_POPUP';
export const DONE_EDIT_INTERNAL_LINKS_SECTION_POPUP =
    'DONE_EDIT_INTERNAL_LINKS_SECTION_POPUP';

/** call to action section **/
export const OPEN_EDIT_CALL_TO_ACTION_SECTION_POPUP =
    'OPEN_EDIT_CALL_TO_ACTION_SECTION_POPUP';
export const CLOSE_EDIT_CALL_TO_ACTION_SECTION_POPUP =
    'CLOSE_EDIT_CALL_TO_ACTION_SECTION_POPUP';
export const DONE_EDIT_CALL_TO_ACTION_SECTION_POPUP =
    'DONE_EDIT_CALL_TO_ACTION_SECTION_POPUP';

/** next steps section **/
export const OPEN_EDIT_NEXT_STEPS_SECTION_POPUP =
    'OPEN_EDIT_NEXT_STEPS_SECTION_POPUP';
export const CLOSE_EDIT_NEXT_STEPS_SECTION_POPUP =
    'CLOSE_EDIT_NEXT_STEPS_SECTION_POPUP';
export const DONE_EDIT_NEXT_STEPS_SECTION_POPUP =
    'DONE_EDIT_NEXT_STEPS_SECTION_POPUP';

/** review snippets section **/
export const OPEN_EDIT_REVIEW_SNIPPETS_SECTION_POPUP =
    'OPEN_EDIT_REVIEWS_SNIPPETS_SECTION_POPUP';
export const CLOSE_EDIT_REVIEW_SNIPPETS_SECTION_POPUP =
    'CLOSE_EDIT_REVIEWS_SNIPPETS_SECTION_POPUP';
export const DONE_EDIT_REVIEW_SNIPPETS_SECTION_POPUP =
    'DONE_EDIT_REVIEWS_SNIPPETS_SECTION_POPUP';

/** faqs section **/
export const OPEN_EDIT_FAQS_SECTION_POPUP = 'OPEN_EDIT_FAQS_SECTION_POPUP';
export const CLOSE_EDIT_FAQS_SECTION_POPUP = 'CLOSE_EDIT_FAQS_SECTION_POPUP';
export const DONE_EDIT_FAQS_SECTION_POPUP = 'DONE_EDIT_FAQS_SECTION_POPUP';

/** find your project section **/
export const OPEN_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP =
    'OPEN_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP';
export const CLOSE_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP =
    'CLOSE_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP';
export const DONE_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP =
    'DONE_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP';

/** large snippets section **/
export const OPEN_EDIT_LARGE_SNIPPETS_SECTION_POPUP =
    'OPEN_EDIT_LARGE_SNIPPETS_SECTION_POPUP';
export const CLOSE_EDIT_LARGE_SNIPPETS_SECTION_POPUP =
    'CLOSE_EDIT_LARGE_SNIPPETS_SECTION_POPUP';
export const DONE_EDIT_LARGE_SNIPPETS_SECTION_POPUP =
    'DONE_EDIT_LARGE_SNIPPETS_SECTION_POPUP';

/** value proposition section **/
export const OPEN_EDIT_VALUE_PROPOSITION_SECTION_POPUP =
    'OPEN_EDIT_VALUE_PROPOSITION_SECTION_POPUP';
export const CLOSE_EDIT_VALUE_PROPOSITION_SECTION_POPUP =
    'CLOSE_EDIT_VALUE_PROPOSITION_SECTION_POPUP';
export const DONE_EDIT_VALUE_PROPOSITION_SECTION_POPUP =
    'DONE_EDIT_VALUE_PROPOSITION_SECTION_POPUP';

/** meet us section **/
export const OPEN_EDIT_MEET_US_SECTION_POPUP =
    'OPEN_EDIT_MEET_US_SECTION_POPUP';
export const CLOSE_EDIT_MEET_US_SECTION_POPUP =
    'CLOSE_EDIT_MEET_US_SECTION_POPUP';
export const DONE_EDIT_MEET_US_SECTION_POPUP =
    'DONE_EDIT_MEET_US_SECTION_POPUP';

/** trip formats carousel section **/
export const OPEN_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP =
    'OPEN_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP';
export const CLOSE_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP =
    'CLOSE_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP';
export const DONE_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP =
    'DONE_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP';

/** group trips banner section **/
export const OPEN_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP =
    'OPEN_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP';
export const CLOSE_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP =
    'CLOSE_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP';
export const DONE_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP =
    'DONE_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP';

/** Page Versions **/
export const FETCHED_PAGE_VERSIONS = 'FETCHED_PAGE_VERSIONS';
export const FETCHED_PAGE_VERSION = 'FETCHED_PAGE_VERSION';
export const DELETED_PAGE_VERSION = 'DELETED_PAGE_VERSION';
export const OPEN_VIEW_PAGE_VERSION_POPUP = 'OPEN_VIEW_PAGE_VERSION_POPUP';
export const CLOSE_VIEW_PAGE_VERSION_POPUP = 'CLOSE_VIEW_PAGE_VERSION_POPUP';
export const UPDATED_PAGE_VERSION = 'UPDATED_PAGE_VERSION';

export const CHANGE_SECTION_BG_COLOR = 'CHANGE_SECTION_BG_COLOR';
export const SET_BG_COLORS = 'SET_BG_COLORS';

export const UPDATE_SECTION = 'UPDATE_SECTION';
export const TOGGLE_SECTION_POPUP = 'TOGGLE_SECTION_POPUP';



// WEBPACK FOOTER //
// ./src/containers/builder/types.js